/**
 * Phone/Email toggle on the login page. Switches the two views and enables only the active view's
 * inputs — disabled inputs aren't submitted and skip `required` validation, so the server sees just the
 * chosen method's fields. Also sets the hidden `method` field the controller reads. No-ops if the markup
 * isn't present (so phone-only still works without JS).
 */
export class LoginToggle {
    static ACTIVE = ['bg-white', 'text-slate-900', 'shadow-sm', 'font-semibold', 'dark:bg-slate-700', 'dark:text-white'];
    static INACTIVE = ['text-slate-500', 'font-medium', 'dark:text-slate-400'];
    static init() {
        const phoneBtn = document.getElementById('togglePhone');
        const emailBtn = document.getElementById('toggleEmail');
        const phoneView = document.getElementById('phoneView');
        const emailView = document.getElementById('emailView');
        const method = document.getElementById('loginMethod');
        if (!phoneBtn || !emailBtn || !phoneView || !emailView || !method)
            return;
        const phoneInputs = phoneView.querySelectorAll('input, select');
        const emailInputs = emailView.querySelectorAll('input, select');
        const select = (isPhone) => {
            method.value = isPhone ? 'phone' : 'email';
            // Remember the choice so a returning user lands on their tab. Read server-side on
            // GET /login (cookie), so the correct tab renders with no flash. Non-sensitive (just the
            // method), 1-year, SameSite=Lax; no Secure so it also works on http://localhost in dev.
            document.cookie = `cd_login_method=${method.value}; Max-Age=31536000; Path=/; SameSite=Lax`;
            phoneView.classList.toggle('hidden', !isPhone);
            emailView.classList.toggle('hidden', isPhone);
            phoneInputs.forEach(el => { el.disabled = !isPhone; });
            emailInputs.forEach(el => { el.disabled = isPhone; });
            phoneBtn.classList.remove(...(isPhone ? LoginToggle.INACTIVE : LoginToggle.ACTIVE));
            phoneBtn.classList.add(...(isPhone ? LoginToggle.ACTIVE : LoginToggle.INACTIVE));
            emailBtn.classList.remove(...(isPhone ? LoginToggle.ACTIVE : LoginToggle.INACTIVE));
            emailBtn.classList.add(...(isPhone ? LoginToggle.INACTIVE : LoginToggle.ACTIVE));
            const focusEl = (isPhone ? document.getElementById('nationalNumber') : document.getElementById('loginEmail'));
            focusEl?.focus();
        };
        phoneBtn.addEventListener('click', () => select(true));
        emailBtn.addEventListener('click', () => select(false));
    }
}
